import { apiGet, apiPost } from '@/auth/api-client';
export function getSubscription() {
    return apiGet('/api/v1/me/subscription');
}
/** Starts checkout for a plan and returns the payment confirmation URL to redirect the user to. */
export function createCheckout(planCode) {
    return apiPost('/api/v1/me/checkout', { planCode });
}
/** Cancels the current user's subscription. By default keeps access until the period end. */
export function cancelSubscription(atPeriodEnd = true) {
    return apiPost('/api/v1/me/subscription/cancel', { atPeriodEnd });
}
/** Отменяет запланированное завершение подписки — она продолжит продлеваться. */
export function resumeSubscription() {
    return apiPost('/api/v1/me/subscription/resume', {});
}
